import { decrypt } from '../../Encryption';

export const userExistAction = key => {
  let value = null;
  if (localStorage.getItem("authorization") !== null) {
    value = decrypt(JSON.parse(localStorage.getItem("authorization"))[key]);
  }
  return value;
};